<script setup lang="ts">
import type { CreateStepDeliveryInput } from '@/types/schema.generated'
import { useAlert } from '@/libs/alertPortal'
import { computed } from 'vue'
import { useRouter } from 'vue-router'
import StepDeliveryForm from '@/components/organisms/StepDeliveryForm/StepDeliveryForm.vue'
import type { StepDeliveryFormType } from '@/components/organisms/StepDeliveryForm/formSchema'
import { useCreateStepDeliveryMutation } from './StepDeliveryNewPageContent.generated'

const alert = useAlert()
const router = useRouter()

const initialForm = computed<StepDeliveryFormType>(() => {
  return {
    name: '',
    startAt: null,
    endAt: null,
    cond: '',
    addFriendDate: null,
    IsDisabled: false,
    steps: [],
  }
})

const createMutation = useCreateStepDeliveryMutation()

const handleSubmit = async (input: CreateStepDeliveryInput) => {
  await createMutation.mutate({
    input: input,
  })

  alert.success('ステップ配信を作成しました')

  // eslint-disable-next-line fp/no-mutating-methods
  await router.push({ name: 'StepDeliveryIndexPage' })
}
</script>

<template>
  <div>
    <h1>ステップ配信 新規作成ページ</h1>
    <StepDeliveryForm
      :initialForm="initialForm"
      @submit="handleSubmit"
      :class="$style.form"
    />
  </div>
</template>

<style module lang="scss">
.form {
  margin-top: 16px;
}
</style>
